import GamePanel from './game-panel'
import React, { PropTypes } from 'react'
import Strings from 'config/strings'
import { createGame } from 'app/actions/game'
import {Link} from 'react-router'

const GameIndex = React.createClass({

  propTypes: {
    app     : PropTypes.object.isRequired,
    history : PropTypes.object.isRequired
  },

  render() {
    return (
      <main className="fill-black">
        <header className="brand">
          <h1>
            <img src="/images/gifbowl.png" alt={ Strings['app.name'] } height="28" width="288" />
          </h1>
          <p className="type-subtitle">{ Strings['app.desc'] }</p>
        </header>

        <div className="game-index__content fill-white text-align-center">
          <div className="container">
            <p className="type-intro pad-5-left pad-5-right">{ Strings['app.intro'] }</p>

            <p className="pad-4">
              <Link to="/about" className="type-btn link-large color-black">Learn How to Play</Link>
            </p>

            <GamePanel app={ this.props.app } history={ this.props.history } />
          </div>
        </div>

        <footer className="fill-black pad-2 color-white type-btn text-align-center">
          Made by <a className="margin-2 inline-block-level" href="http://viget.com"><img alt="Viget Labs" src="/images/viget.png"  width="103" height="38" /></a>
          Powered by <a className="margin-2 inline-block-level" href="http://giphy.com"><img alt="Giphy" src="/images/giphy.png" width="31" height="34" /></a>
        </footer>
      </main>
    )
  }
})

export default GameIndex



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/index.jsx
 **/